import { render, staticRenderFns } from "./SettingsEditor.vue?vue&type=template&id=747945d3&scoped=true&"
import script from "./SettingsEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsEditor.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEditor.vue?vue&type=style&index=0&id=747945d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747945d3",
  null
  
)

export default component.exports